/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2025-03-15 11:08:27
 * @LastEditors: caizexin caizexin@kjgb.net
 * @LastEditTime: 2025-07-07 15:48:36
 * @FilePath: \vue-hd-ota\src\views\firmware\js\formConfig.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// 固件列表查询
const QueryForm = {
    labelCol: { style: { width: '100px' } },
    wrapperCol: { span: 14 },
    formData:{},
    formField:[
        // {
        //     key:'fault_name',
        //     type:'input',
        //     allowClear:true,
        //     width:'180px',
        //     placeholder_lang:'按故障名称查询',
        // },
        {
            key:'chip_id',
            type:'input',
            allowClear:true,
            width:'220px',
            placeholder_lang:'按芯片ID查询',
        },
    ]
}


QueryForm.formField.forEach(item=>{
    QueryForm.formData[item.key] = ''
    if(item.key == 'environment' || item.key == 'status'){
        QueryForm.formData[item.key] = null
    }
})

export {
    QueryForm
}